import produce from "immer";
import { AccountManagement } from "pages/Rules/Form/Steps/CloudStorage/utils";
import { verifyIfCanSave } from "./verifyIfCanSave";
import { ruleTypeMap } from "../helpers";
import { State, Step } from "../types";
import initStorageLocation from "../initStorageLocation";

type Payload = { currentStep: Step; action: "ADD" | "REMOVE" };

export type ToggleStorageSteps = {
  type: "toggleStorageSteps";
  payload: Payload;
};

export function toggleStorageSteps(state: State, payload: Payload) {
  const { action, currentStep } = payload;

  return produce(state, draft => {
    const ruleType = ruleTypeMap.get(state.type);
    draft.currentStep = currentStep;

    if (action === "REMOVE") {
      delete draft.storageManagement;
      delete draft.steps.cloudStorage;
      delete draft.steps.storageFilepath;
      delete draft.steps.moreActions;
      delete draft.rule[ruleType].storage;
      draft.currentStep = "target";
      draft.steps.target.next = null;
    }

    if (action === "ADD") {
      draft.storageManagement = AccountManagement.AUTO;
      draft.steps.target.next = "cloudStorage";
      draft.steps.cloudStorage = {
        done: false,
        valid: false,
        expanded: true,
        next: "storageFilepath",
      };

      draft.steps.storageFilepath = {
        done: false,
        valid: true,
        expanded: false,
        next: null,
      };

      draft.steps.moreActions = {
        done: true,
        valid: true,
        expanded: false,
        next: null,
      };

      draft.storageManagement = AccountManagement.AUTO;

      draft.rule[ruleType].storage = {
        provider: "MXHERO_STORAGE",
        authentication: "ORGANIZATION",
        syncAllByRule: false,
        userIds: [],
        asUsers: [],
        location: { folderStructure: null },
        override: true,
        allManagedUserIds: false,
      };

      if (draft.type === "ZIP_ATTACHMENTS") {
        const passwordPerRecipient =
          draft.rule.zipAttachments.passwordPerRecipient;

        if (passwordPerRecipient) {
          // https://mxhero.atlassian.net/browse/MXH-5211
          // INDIVIDUAL zip password =>
          //        passwordPerRecipient = true y el syncAllByRule = false
          draft.rule.zipAttachments.storage.syncAllByRule = false;
        } else {
          // SAME zip password =>
          //        passwordPerRecipient = false y el syncAllByRule = true

          draft.rule.zipAttachments.storage.syncAllByRule = true;
        }

        draft.rule.zipAttachments.storage.location = initStorageLocation(
          draft.type,
          draft.rule.targetType,
          draft.rule.zipAttachments.storage
        );
      }
    }

    verifyIfCanSave(draft);
  });
}
